import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import withRecoil from '../../withRecoil';
import queryString from "query-string";
import api from '../../api/api/index';
import { Form, Input, DatePicker, Modal, Select, Spin } from 'antd';
import moment from 'moment';
import { us_state_abbrevs_names, countries_names } from "../../locations";
import { accessTokenState, phoneState, emailState, nameState } from '../../atoms';
import { withTranslation } from 'react-i18next';

class Setup2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false, // submit button spinner
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    this.props.form.validateFields((err, values) => {
      if (!err && values) {
        const body = {
          access_token: this.props.recoilStates.accessTokenState.state,
          name: values.name,
          dob: values.dob,
          city: values.city,
          state: values.state,
          zipcode: values.zipcode,
          country: values.country
        };

        fetch(`${api.extra}/api/update_user_information`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: queryString.stringify(body)
        })
          .then(response => {
            return response.json().then(data => {
              if (!response.ok) {
                throw new Error(data.message || this.props.t('setup:failedUpdate'));
              }
              this.props.goToStep(3);
            });
          })
          .catch((error) => {
            Modal.error({
              title: this.props.t('common:error'),
              content: error.message,
            });
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      } else {
        this.setState({ loading: false });
        Modal.error({
          title: this.props.t('common:error'),
          content: this.props.t('setup:formInvalid'),
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { t } = this.props;
    const minDOB = moment().subtract(18, "years").endOf("day");

    return (
      <div>
        <div style={{ position: 'relative', marginBottom: '20px', textAlign: 'center', width: '100%' }}>
          <div className='spare'>
            <h2 style={{ textAlign: "center", margin: "0" }}>{t('setup:title')}</h2>
          </div>
        </div>

        <div style={{ width: '100%', padding: "10px" }}>
          <Form onSubmit={this.handleSubmit} layout="vertical" style={{ width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Form.Item label={t('setup:name')} style={{ marginRight: '5px', flex: '1', width: '100%' }}>
                {getFieldDecorator('name', {
                  initialValue: this.props.recoilStates.nameState.state,
                })(
                  <Input readOnly />
                )}
              </Form.Item>
            </div>

            <div>
              <Form.Item label={t('setup:phone')} style={{ marginRight: '5px', flex: '1', width: '100%' }}>
                {getFieldDecorator('phone', {
                  initialValue: this.props.recoilStates.phoneState.state,
                })(
                  <Input readOnly />
                )}
              </Form.Item>

              <Form.Item label={t('setup:dobLabel')} style={{ flex: '1', width: '100%' }}>
                {getFieldDecorator('dob', {
                  rules: [{ required: true, message: t('setup:dobRequired') }],
                })(
                  <DatePicker
                    placeholder={t('setup:dobPlaceholder')}
                    picker="date"
                    style={{ width: '100%' }}
                    disabledDate={(current) => current && current.isAfter(minDOB)}
                  />
                )}
              </Form.Item>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: "15px" }}>
              <Form.Item label={t('setup:email')} style={{ marginRight: '5px', flex: '1', width: '100%' }}>
                {getFieldDecorator('email', {
                  initialValue: this.props.recoilStates.emailState.state,
                })(
                  <Input readOnly />
                )}
              </Form.Item>

              <Form.Item label={t('setup:city')} style={{ flex: '1', width: '100%' }}>
                {getFieldDecorator('city', {
                  rules: [{ required: true, message: t('setup:cityRequired') }],
                })(
                  <Input />
                )}
              </Form.Item>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: "15px" }}>
              <Form.Item label={t('setup:state')} style={{ marginRight: '5px', flex: '1', width: '100%' }}>
                {getFieldDecorator('state', {
                  rules: [{ required: true, message: t('setup:stateRequired') }],
                })(
                  <Select showSearch>
                    {Object.entries(us_state_abbrevs_names).map(([stateAbbrev, state]) => (
                      <Select.Option key={stateAbbrev} value={stateAbbrev}>{state}</Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label={t('setup:zip')} style={{ marginRight: '5px', flex: '1', width: '100%' }}>
                {getFieldDecorator('zipcode', {
                  rules: [
                    { required: true, message: t('setup:zipRequired') },
                    { len: 5, message: t('setup:zipLen') }
                  ],
                })(
                  <Input />
                )}
              </Form.Item>

              <Form.Item label={t('setup:country')} style={{ flex: '1', width: '100%' }}>
                {getFieldDecorator('country', {
                  initialValue: 'United States',
                  rules: [{ required: true, message: t('setup:countryRequired') }],
                })(
                  <Select showSearch placeholder={t('setup:countryPlaceholder')} style={{ width: '100%' }}>
                    {countries_names.map((country, index) => (
                      <Select.Option key={index} value={country}>
                        {country}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Form.Item>
                <button className="action-button btn" type="submit" disabled={this.state.loading}>
                  {t('setup:submit')}
                </button>
              </Form.Item>

              {this.state.loading && (
                <Spin size="small" style={{ marginLeft: "5px", color: "blue" }} />
              )}
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

// Wrap with i18n first, then Form.create, then withRouter/withRecoil
const TranslatedSetup2 = withTranslation(['setup', 'common'])(Setup2);
const WrappedSetup2 = Form.create({ name: 'setup2' })(TranslatedSetup2);

export default withRouter(
  withRecoil(WrappedSetup2, [accessTokenState, phoneState, nameState, emailState])
);